import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export const ExemptionPropertyDamagedDisclaimer = (props: { disclaimerText: string; onClose: () => void }) => {
 const { onClose, disclaimerText } = props;

 return (
   <Dialog title="Attention" width={800} closeIcon={false}>
    
     <div style={{ whiteSpace: "pre-wrap", marginBottom: "1rem" }}>
       {disclaimerText || "No disclaimer text has been provided for this form."}
     </div>

     <DialogActionsBar>
       <div className="d-flex justify-content-center">
         <Button className="k-button" onClick={onClose}>Continue</Button>
       </div>
     </DialogActionsBar>
   </Dialog>
 );
};